{
  "list": {
    "title": "智能短语",
    "backToDashboard": "工作台",
    "newButton": "新建短语",
    "import": "导入",
    "export": "导出",
    "searchPlaceholder": "按关键字或扩展文本搜索...",
    "filterAllCategories": "全部分类",
    "header": "短语 ({{count}})",
    "loading": "正在加载短语...",
    "empty": "未找到短语。请创建您的第一条智能短语。",
    "authoredBy": "作者:{{name}}",
    "tooltips": {
      "preview": "预览",
      "edit": "编辑",
      "delete": "删除"
    },
    "confirmDelete": "确认",
    "cancelDelete": "取消",
    "previewLabel": "预览:",
    "closePreview": "关闭预览",
    "toast": {
      "deleted": "短语已删除",
      "importComingSoon": "导入功能即将推出",
      "exportComingSoon": "导出功能即将推出"
    }
  },
  "form": {
    "editTitle": "编辑智能短语",
    "createTitle": "新建智能短语",
    "fields": {
      "key": "关键字",
      "category": "分类",
      "expansionText": "扩展文本"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "必须以 \".\" 开头",
    "categoryUncategorized": "未分类",
    "expansionPlaceholder": "输入将替换该快捷键的文本...",
    "cancel": "取消",
    "create": "创建短语",
    "update": "更新短语",
    "toast": {
      "created": "短语已创建",
      "updated": "短语已更新",
      "saveFailed": "保存短语失败",
      "keyMustStartWithDot": "关键字必须以 \".\" 开头",
      "keyTooShort": "关键字至少为 2 个字符",
      "expansionRequired": "扩展文本不能为空"
    }
  },
  "category": {
    "general": "一般",
    "physicalExam": "体格检查",
    "reviewOfSystems": "系统回顾",
    "assessment": "评估",
    "plan": "计划",
    "instructions": "医嘱说明",
    "medications": "药物",
    "history": "病史"
  }
}
